export const oidcSettings = {
  authority: process.env.VUE_APP_AUTH_AUTHORITY,
  clientId: "accent-fix",
  redirectUri: process.env.VUE_APP_AUTH_REDIRECT_URI,
  responseType: "id_token token",
  scope: "openid accentfix-scope email",
  silentRedirectUri: process.env.VUE_APP_AUTH_SILENT_REDIRECT_URI,
  automaticSilentRenew: true, // If true oidc-client will try to renew your token when it is about to expire
  automaticSilentSignin: true // If true vuex-oidc will try to silently signin unauthenticated users on public routes. Defaults to true
};
